import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { LanguageService } from '../core/language';

@Component({
  selector: 'app-legal',
  imports: [RouterLink],
  templateUrl: './legal.html',
})
export class LegalPage {
  private readonly data = toSignal(inject(ActivatedRoute).data);
  protected readonly lang = inject(LanguageService);
  protected readonly page = computed(() => {
    this.lang.code();
    const slug = String(this.data()?.['page'] ?? 'risk');
    if (slug === 'privacy') {
      return { slug, title: this.lang.t('lgPrivT'), body: [this.lang.t('lgPriv1')] };
    }
    if (slug === 'cookies') {
      return { slug, title: this.lang.t('lgCookT'), body: [this.lang.t('lgCook1')] };
    }
    if (slug === 'aml') {
      return { slug, title: this.lang.t('lgAmlT'), body: [this.lang.t('lgAml1'), this.lang.t('lgTerms3')] };
    }
    if (slug === 'terms') {
      return { slug, title: this.lang.t('lgTermsT'), body: [this.lang.t('lgTerms1'), this.lang.t('lgTerms2'), this.lang.t('lgTerms3')] };
    }
    return { slug, title: this.lang.t('lgRiskT'), body: [this.lang.t('lgRisk1'), this.lang.t('lgRisk2')] };
  });
}
